import { SvgIcon, SvgIconProps } from "@mui/material";

export const PersonSpeakingIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props}>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_26686_624)">
					<path
						d="M10.125 15.75C13.2316 15.75 15.75 13.2316 15.75 10.125C15.75 7.0184 13.2316 4.5 10.125 4.5C7.0184 4.5 4.5 7.0184 4.5 10.125C4.5 13.2316 7.0184 15.75 10.125 15.75Z"
						stroke="#42296E"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M2.25 19.5C4.17656 17.2078 6.89625 15.75 10.125 15.75C13.3537 15.75 16.0734 17.2078 18 19.5"
						stroke="#42296E"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.75 6.44434C19.2449 7.6083 19.5 8.86014 19.5 10.125C19.5 11.3898 19.2449 12.6416 18.75 13.8056"
						stroke="#42296E"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M21.5024 5.25C22.1606 6.791 22.4999 8.44933 22.4999 10.125C22.4999 11.8007 22.1606 13.459 21.5024 15"
						stroke="#42296E"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
				<defs>
					<clipPath id="clip0_26686_624">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</SvgIcon>
	);
};

export const EmptyBoxIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props}>
			<svg width="140" height="97" viewBox="0 0 140 97" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M124.867 75.1432L59.3201 95.3114L16.1024 75.1432L15.6908 53.5344L6.7386 49.2127L16.1024 35.5271L1.69653 23.2821L71.5651 1.67334L81.6493 13.9183L94.6146 1.67334L137.832 23.2821L124.867 35.5271L137.832 49.2127L135.671 49.9329L124.867 53.8177V75.1432Z"
					fill="#ECEAF1"
				/>
				<path
					d="M59.3201 57.1359V95.3114M59.3201 57.1359L48.5157 69.3808L15.6908 53.5344M59.3201 57.1359L124.867 35.5271M59.3201 57.1359L71.5651 72.9823L135.671 49.9329M59.3201 57.1359L16.1024 35.5271M59.3201 95.3114L124.867 75.1432V53.5344L135.671 49.9329M59.3201 95.3114L16.1024 75.1432L15.6908 53.5344M124.867 35.5271L137.832 49.2127L135.671 49.9329M124.867 35.5271L137.832 23.2821L94.6146 1.67334L81.6493 13.9183M124.867 35.5271L81.6493 13.9183M81.6493 13.9183L71.5651 1.67334L1.69653 23.2821L16.1024 35.5271M81.6493 13.9183V49.2127M81.6493 13.9183L16.1024 35.5271M16.1024 35.5271L6.7386 49.2127L15.6908 53.5344"
					stroke="#35363A"
					strokeWidth="1.44059"
				/>
			</svg>
		</SvgIcon>
	);
};
